import React from "react";
import * as agent from "../agent";
import { connect } from "react-redux";
import { formValueSelector, reduxForm, Field } from "redux-form";
import { normalizeMoney, required, formatPhone, validatePhone } from "../utility";
import { Masks } from "../constants/enums";
import { MaterialTextField, MaterialMaskedTextField } from "./MaterialInput";
import PrintLink from './PrintLink';
import SubmitButton from './SubmitButton';
import SwipeableViews from 'react-swipeable-views';
import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';
import PersonAddIcon from '@material-ui/icons/PersonAdd';
import ExitToAppIcon from '@material-ui/icons/ExitToApp';
import MaterialCombobox from "./MaterialCombobox";
import Button from '@material-ui/core/Button';
import Collapse from '@material-ui/core/Collapse';
import Grid from '@material-ui/core/Grid';
import MenuItem from '@material-ui/core/MenuItem';
import Paper from '@material-ui/core/Paper';
import Typography from '@material-ui/core/Typography';

const TradeSecond = ({carId, trader, switchTab, onStatusSubmit}) => {
    const doc = trader === "AF" ? "sale" : "salep2p";
    return (
        <Paper className="common-paper" style={{ marginTop: 20, marginBottom: 20 }}>
            <Typography variant="h5" gutterBottom>Печать документов</Typography>
            <PrintLink href={agent.src.print(doc, carId)}
                       label="Договор купли-продажи" />
            <Grid container justify="center" spacing={16} style={{ marginTop: 20 }}>
                <Grid item className="common-column">
                    <Button fullWidth
                            onClick={e => {
                                e.preventDefault();
                                switchTab(null, 0);
                            }}
                            size="large"
                            variant="contained" >Назад</Button>
                </Grid>
                <Grid item className="common-column">
                    <Button fullWidth
                            type="submit"
                            onClick={() => onStatusSubmit(carId, "CLOSED")}
                            size="large"
                            color="primary"
                            variant="contained" >Закрыть займ</Button>
                </Grid>
            </Grid>
        </Paper>
    );
};

const tradeFirst = ({ carId, managersLoaded, managers = [], pickedTrader, switchTab, onTradeCar, onStatusSubmit, handleSubmit }) => {
    const prepareData = data => {
        if(data.prices) {
            data.prices.tradeSum = Number(`${data.prices.tradeSum}`.replace(/\s/g,``));
            data.prices.clientSum = Number(`${data.prices.clientSum}`.replace(/\s/g,``))
            data.prices.comissionSum = Number(`${data.prices.comissionSum}`.replace(/\s/g,``));
            data.prices.depositSum = Number(`${data.prices.depositSum}`.replace(/\s/g,``));
        }
        return data;
    };

    return (
        <Paper className="common-paper" style={{ marginTop: 20, marginBottom: 20 }}>
            <form onSubmit={handleSubmit(data => onTradeCar(carId, prepareData(data), () => switchTab(null, 1))) } >
                <Grid container justify="center" spacing={16}>
                    <Grid item className="common-form common-column">
                        <Typography variant="h5" gutterBottom>Покупатель:</Typography>
                        <Field name="purchaserFirstname"
                               component={MaterialTextField}
                               validate={required}
                               label="Имя" />
                        <Field name="purchaserLastname"
                               component={MaterialTextField}
                               validate={required}
                               label="Фамилия" />
                        <Field name="purchaserPatronymic"
                               component={MaterialTextField}
                               validate={required}
                               label="Отчество" />
                        <Field name="sex"
                               select
                               component={MaterialTextField}
                               validate={required}
                               label="Пол" >
                            <MenuItem value="M">Мужской</MenuItem>
                            <MenuItem value="F">Женский</MenuItem>
                        </Field>
                        <Field name="purchaserBirthDate"
                               component={MaterialMaskedTextField}
                               mask={Masks.date}
                               validate={required}
                               label="Дата рождения" />
                        <Field name="purchaserBirthPlace"
                               component={MaterialTextField}
                               validate={required}
                               label="Место рождения" />
                        <Field name="purchaserPhone"
                               component={MaterialMaskedTextField}
                               mask={Masks.phone}
                               format={formatPhone}
                               validate={validatePhone}
                               placeholder="+7 (___) ___-__-__"
                               label="Номер телефона" />
                        <Field name="purchaserEmail"
                               component={MaterialTextField}
                               label="Электронная почта" />
                    </Grid>
                    <Grid item className="common-form common-column">
                        <Typography variant="h5" gutterBottom>Паспорт:</Typography>
                        <Field name="purchaserPassportSerie"
                               component={MaterialMaskedTextField}
                               validate={required}
                               mask={Masks.passportSerie}
                               label="Серия паспорта" />
                        <Field name="purchaserPassportNumber"
                               component={MaterialMaskedTextField}
                               validate={required}
                               mask={Masks.passportNumber}
                               label="Номер паспорта" />
                        <Field name="purchaserPassportDate"
                               component={MaterialMaskedTextField}
                               validate={required}
                               mask={Masks.date}
                               label="Дата выдачи" />
                        <Field name="purchaserPassportCode"
                               component={MaterialMaskedTextField}
                               validate={required}
                               mask={Masks.code}
                               label="Код подразделения" />
                        <Field name="purchaserPassportIssued"
                               component={MaterialTextField}
                               rows={5}
                               multiline
                               validate={required}
                               label="Кем выдан" />
                        <Field component={MaterialTextField}
                               token="d1eb73a80efc7afd745c318e28b68d722471d573"
                               query="Санкт-Петербург"
                               rows={5}
                               multiline
                               name="purchaserAddressRegister"
                               label="Адрес регистрации"/>
                    </Grid>
                    <Grid item className="common-form common-column">
                        <Typography variant="h5" gutterBottom>Данные продажи:</Typography>
                        <Field name="prices.tradeSum"
                               endAdornment="₽"
                               format={normalizeMoney}
                               validate={required}
                               component={MaterialTextField}
                               normalize={normalizeMoney}
                               label="Цена продажи"/>
                        <Field name="trader"
                               select
                               component={MaterialTextField}
                               validate={required}
                               label="Продавец" >
                            <MenuItem value="AF">ЗАО «Авто-Финанс»</MenuItem>
                            <MenuItem value="CT">COM-TRADE</MenuItem>
                        </Field>
                        <Collapse in={pickedTrader === "AF"} classes={{ container: "collapse-wrapper" }}>
                            {pickedTrader === "AF" &&
                                <div className="common-form">
                                    <Field name="prices.depositSum"
                                           endAdornment="₽"
                                           format={normalizeMoney}
                                           validate={required}
                                           component={MaterialTextField}
                                           normalize={normalizeMoney}
                                           label="Залог"/>
                                    <Field component={MaterialTextField}
                                           select
                                           disabled={!managersLoaded}
                                           validate={required}
                                           name="manager"
                                           label="Ведущий менеджер">
                                       {managers.map(({ _id, fullname}, i) => {
                                           const [ managerLastname, managerFirstname = "", managerThirdname = "" ] = fullname.split(" ");
                                           return <MenuItem key={i} value={_id}>{`${managerLastname} ${managerFirstname[0]}. ${managerThirdname[0]}.`}</MenuItem>
                                       })}
                                    </Field>
                                    <Field component={MaterialMaskedTextField}
                                           mask={Masks.stsSerie}
                                           name="stsSerie"
                                           label="Серия СТС"/>
                                    <Field component={MaterialMaskedTextField}
                                           mask={Masks.stsNumber}
                                           name="stsNumber"
                                           label="Номер СТС"/>
                                    <Field component={MaterialMaskedTextField}
                                           mask={Masks.date}
                                           name="stsDate"
                                           label="Дата выдачи СТС"/>
                                    <Field name="stsIssued"
                                           component={MaterialCombobox}
                                           rows={5}
                                           multiline
                                           suggestions={[]}
                                           label="Кем выдан СТС" />
                                </div>
                            }
                         </Collapse>
                         <Collapse in={pickedTrader === "CT"} classes={{ container: "collapse-wrapper" }}>
                            {pickedTrader === "CT" &&
                                <div className="common-form">
                                    <Field name="prices.comissionSum"
                                           endAdornment="₽"
                                           format={normalizeMoney}
                                           component={MaterialTextField}
                                           normalize={normalizeMoney}
                                           label="Комиссия"/>
                                    <Field name="prices.clientSum"
                                           endAdornment="₽"
                                           format={normalizeMoney}
                                           component={MaterialTextField}
                                           normalize={normalizeMoney}
                                           label="Возврат клиенту"/>
                                </div>
                            }
                        </Collapse>
                    </Grid>
                </Grid>
                <Grid container justify="center" spacing={16}>
                    <Grid item className="common-form common-column">
                        <Button fullWidth
                                 onClick={e => {
                                    e.preventDefault();
                                    onStatusSubmit(carId, "ACTIVE");
                                 }}
                                 size="large"
                                 variant="contained" >Отменить продажу</Button>
                    </Grid>
                    <Grid item xs>
                    </Grid>
                    <Grid item className="common-form common-column">
                        <SubmitButton label="Далее" />
                    </Grid>
                </Grid>
            </form>
        </Paper>
)};

const TradeFirst = connect(
    (state, props) => {
        const { trader, prices, purchaser, carDetails: {stsSerie, stsNumber, stsDate, stsIssued} } = props;
        return {
            pickedTrader: formValueSelector("trade-first-form")(state, "trader"),
            initialValues: {
                manager: state.common.user.id,
                stsSerie,
                stsNumber,
                stsDate,
                stsIssued,
                trader,
                prices,
                ...purchaser,
            },
        };
    },
    null
)(reduxForm({ form: "trade-first-form" })(tradeFirst));


const tabs = [
    { label: "Данные продажи", icon: <PersonAddIcon /> },
    { label: "Документы", icon: <ExitToAppIcon /> }
];

class LoanTrade extends React.Component {

    constructor(props) {
        super();
        const index = ["FIRST", "SECOND"].indexOf(props.tradeStatus);
        this.state = {
            value: index > 0 ? index : 0,
            managersLoaded: false,
            managers: []
        }
    }

    componentWillMount = () => {
        const { isJur } = this.props;
        agent.User.managers(isJur)
            .then(res => this.setState({ managersLoaded: true, managers: res.managers }))
            .catch(e => alert(e.message));
    }

    switchTab = (e, value) => this.setState({ value });

    render() {
        const { value, managersLoaded, managers } = this.state;

        return (
            <React.Fragment>
                <Tabs value={value}
                      onChange={this.switchTab}
                      centered >
                    {tabs.map((tab, i) => <Tab key={i}
                                               disabled={value < i}
                                               label={tabs[i].label}
                                               icon={tabs[i].icon} />
                    )}
                </Tabs>
                <SwipeableViews axis="x" index={value}>
                    <div dir="x">
                        {value === 0 && <TradeFirst managersLoaded={managersLoaded}
                                                    managers={managers}
                                                    switchTab={this.switchTab}
                                                    {...this.props}  /> }
                    </div>
                    <div dir="x">
                        {value === 1 && <TradeSecond switchTab={this.switchTab}
                                                     {...this.props} /> }
                    </div>
                </SwipeableViews>
            </React.Fragment>
        );
    }
}

export default LoanTrade;



// WEBPACK FOOTER //
// ./src/components/LoanTrade.js